import React from 'react';
import cx from 'classnames';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';

import { ContentfulImg } from 'ha/modules/Contentful/components/ContentfulImg';
import { Typography } from '@ha/dsl';

const styles = () =>
  createStyles({
    container: {
      display: 'block',
      padding: '0.7rem 0',
    },
    image: {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    },
  });

interface Props {
  title?: string;
  src: string;
}

const MarkdownImageInternal: React.FC<Props & WithStyles<typeof styles>> = ({
  title,
  src,
  classes,
}) => (
  <span className={classes.container}>
    <ContentfulImg className={cx(classes.image)} src={src} />
    {title && (
      <Typography.Paragraph component="span" color="muted">
        {title}
      </Typography.Paragraph>
    )}
  </span>
);

const MarkdownImage = withStyles(styles)(MarkdownImageInternal);
export { MarkdownImage };
